<template>
	<!-- 考评主体弹窗 -->
	<div class="checkMainBody" id="checkMainBody">
		<el-dialog :visible="true" :before-close="closeDialog">
			<table cellpadding="0" cellspacing="0" class="eos_layout_class" width="100%" height="100%">
				<input type="hidden" name="bizCode" filter="false">
				<tbody>
					<tr layout="1">
						<td style="width:100%;height:30px;line-height: 30px;">
							<table style="width:100%;" class="toolbar">
								<tbody>
									<tr>
										<td style="width:60%">
											<b>机构类别：</b>
											<select v-model="orgType" @change="refreshList">
												<option value="质量">质量站</option>
												<option value="安全">安全站</option>
												<option value="质量安全">质量安全站</option>
												<option value="质量、安全、质量安全">质量、安全、质量安全站</option>
												<option value="建设局">建设局</option>
												<option value="造价">造价站</option>
												<option value="" selected="selected">所有</option>
											</select>
										</td>
										<td style="width:40%;">
											<b>去除已创建的机构:</b>
											<span>
												<input type="hidden" id="ckb3039096" name="isCheck" value="true">
												<input type="checkbox" v-model="isCutDown" @click="refreshList">
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
					<tr layout="1" v-loading="loading" >
						<td style="height:100%;width:100%;vertical-align:top;">
							<h4>涉及工作流，暂不开发</h4>
						</td>
					</tr>
					<tr layout="1">
						<td style="width:100%;height:30px;">
							<div style="text-align:center;line-height:30px;" class="toolbar">
								<input type="button" value="确定" @click="returnMainBody" class="btn btn-priamry">
								<input type="button" value="取消" @click="closeDialog" class="btn btn-priamry">
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ["checkMainBody"],
	data() {
		return {
			orgType: "",
			isCutDown:true,//默认去除已创建的机构
			loading: false,
		}
	},
	methods: {
		returnMainBody() {
			this.$emit("passMainBody" , this.orgType)
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("closeDialog")
		},
		refreshList(){
			
		}
	}
}
</script>




// WEBPACK FOOTER //
// check_main_body.vue?537626c8